export const VegaButtonTypes = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	OUTLINE: 'outline',
	SHARE: 'share',
	LINK: 'link'
}
